"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrogravityNutrition = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
const Resources_1 = require("../../Resources");
class MicrogravityNutrition extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MICROGRAVITY_NUTRITION,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.PLANT],
            cost: 11,
            metadata: {
                cardNumber: 'P79',
                description: 'Increase your M€ production 1 step for each colony you have.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(1).slash().colonies(1, Size_1.Size.SMALL));
                }),
                victoryPoints: 1,
            },
        });
    }
    play(player) {
        const coloniesCount = player.getColoniesCount();
        player.addProduction(Resources_1.Resources.MEGACREDITS, coloniesCount, { log: true });
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.MicrogravityNutrition = MicrogravityNutrition;
//# sourceMappingURL=MicrogravityNutrition.js.map